export function gaussianElimination(inMat: number[][]) {
  /*
  inMat = [
    [1, 2, 2, -1],
    [2, 3, 3, -1],
    [-2, 0, 0, -3],
    [-8, 1, 1, -2],
  ];
  */

  let M = inMat.map((arr) => arr.slice());

  let lead = 0;
  const rowCount = M.length;
  const columnCount = M[0].length;

  for (let r = 0; r < rowCount; r++) {
    if (columnCount <= lead) {
      break;
    }
    let i = r;
    while (M[i][lead] === 0) {
      i = i + 1;
      if (rowCount === i) {
        i = r;
        lead = lead + 1;
        if (columnCount === lead) {
          break;
        }
      }
    }
    if (columnCount === lead) {
      break;
    }
    // Swap rows i and r
    M[r] = M[i].slice();
    M[i] = M[r].slice();

    let leadValue = M[r][lead];
    if (leadValue !== 0) {
      M[r] = M[r].map((val) => val / leadValue);
    }

    for (i = 0; i < rowCount; i++)
      if (i !== r) {
        let sub = M[r].map((val) => val * M[i][lead]);
        M[i] = M[i].map((val, index) => val - sub[index]);
      }
    lead = lead + 1;
  }
  return M;
}
